import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var RotateLeftSvg = function RotateLeftSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.59 2.5a9.33 9.33 0 0 1 6.186 2.337 9.53 9.53 0 0 1 3.137 5.877 9.6 9.6 0 0 1-1.463 6.513 9.4 9.4 0 0 1-5.34 3.93 9.3 9.3 0 0 1-6.579-.597 9.46 9.46 0 0 1-4.565-4.827l1.363-.589a7.96 7.96 0 0 0 3.845 4.066 7.83 7.83 0 0 0 5.54.502 7.92 7.92 0 0 0 4.499-3.31 8.07 8.07 0 0 0 1.232-5.485 8.03 8.03 0 0 0-2.642-4.95 7.86 7.86 0 0 0-5.211-1.969 7.86 7.86 0 0 0-5.205 1.987A8 8 0 0 0 5.01 9.76l2.912-.944.452 1.427-4.826 1.564L2 6.927l1.411-.457.564 1.777A9.5 9.5 0 0 1 6.41 4.858 9.34 9.34 0 0 1 12.59 2.5",
      clipRule: "evenodd"
    })
  });
};
export var RotateLeft = function RotateLeft(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: RotateLeftSvg
  }));
};